import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3;
import React from 'react';
import styled, { css } from 'styled-components';
import { Flex } from '../Flex';
import { withPaddings } from '../../mixins';
import { containerDefaultProps } from './props';
const withType = _ref => {
  let {
    type = containerDefaultProps.type
  } = _ref;
  const types = {
    outlined: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      border: var(--border-width-hairline) solid var(--container-border-color-outlined);\n    "]))),
    elevated: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      box-shadow: var(--shadow-level-3);\n    "])))
  };
  return types[type];
};
export const ContainerWrapper = styled(props => {
  return React.createElement(Flex, Object.assign({
    "data-ds-component": "DS-Container"
  }, props));
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: var(--container-background-color);\n  border-radius: var(--border-radius-sm);\n  padding: var(--spacing-2);\n  overflow: hidden;\n  ", "\n  ", "\n"])), withType, withPaddings);